import CaretRight from '@/shared/assets/caret-right.svg';
import { Box } from '@/shared/ui/box';
import { CurrencyBlock } from './styles';
import {
  BodyTextBoldPrimary,
  BodyTextRegularSecondary,
} from '@/shared/ui/typography';
import { Image } from '@/shared/ui/image';
const Currency = ({ currency, onClick }) => {
  return (
    <CurrencyBlock onClick={onClick}>
      <Box $display="flex" $gap={10} $alignItems="center">
        <Image width={36} height={36} src={currency.logo} />
        <Box $textAlign="left">
          <BodyTextBoldPrimary>{currency.name}</BodyTextBoldPrimary>
          <BodyTextRegularSecondary color="#AFAFAF">
            {currency.code}
          </BodyTextRegularSecondary>
        </Box>
      </Box>
      <CaretRight />
    </CurrencyBlock>
  );
};

export { Currency };
